import React, { Fragment, useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { FormGroup } from 'react-bootstrap';
import TimePicker from 'react-times';
import 'react-times/css/classic/default.css';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { DatePickerInput } from 'rc-datepicker';
import './carnival.css';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const CarnivalForm = ({
  handleValue,
  leadInfraId,
  getLeadInfraId,
  prefilledData
}) => {
    const inputs = {
        start_date: '',
        start_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
        end_date: '',
        end_time: `${new Date().getHours()}:${new Date().getMinutes()}`,

    };
    const [inputList, setInputList] = useState([{ name:"",image_url: "", position: ""}]);
    const [formData, setData] = useState(inputs);
    const [infraId, setInfraId] = useState(0);
    const [projectName, setProjectName] = useState();
    const [infraIdToCheck, setInfraIdToCheck] = useState();
    // const [rwaMember, setRwaMember] = useState();
    const [minDateIndex, setMinDateIndex] = useState(null);
    const [addMembers, setAddMembers] = useState(0);
    const [isEditForm, setIsEditForm] = useState(false);
    // const [rwaImage, setRwaImage] = useState();

    useEffect(() => {
        if (leadInfraId?.status == 1 && leadInfraId.infra_project_id == infraIdToCheck) {
            if (leadInfraId?.infra_project_id) {
                setInfraId(leadInfraId?.infra_project_id);
                setProjectName(leadInfraId?.project_name);
                setData({ ...formData, subject: leadInfraId?.project_name })
            }
        }
        if(leadInfraId?.status == 0 && infraIdToCheck !== null) {
            // console.log('rete');
            toast.error('Project Id not found.');
            setInfraId(0);
        }
    }, [leadInfraId]);

    const handleStartDate = (date, dateString) => {
        setData({ ...formData, start_date: dateString });
        setMinDateIndex(dateString);
    };

    const handleEndDate = (date, dateString) => {
        setData({ ...formData, end_date: dateString });
    };

    useEffect(() => {
        if (prefilledData?.carnival !== null && prefilledData?.carnival !== undefined) {
            const {
                id,
                infra_id,
                name,
                start_date,
                start_time,
                end_date,
                end_time,
                project_name,
                // member_exists
            } = prefilledData?.carnival;
            checkInfraId(infra_id);
            // setTimeout(() => {
                setInfraIdToCheck(infra_id);
                setInfraId(infra_id);
                setProjectName(project_name);
                setIsEditForm(true);
                setData({ ...formData,
                    isEdit: 1,
                    start_date: start_date,
                    end_date: end_date,
                    start_time: start_time,
                    end_time: end_time,
                    // rwa_members: (member_exists == 1) ? 1 : 2,
                    // members: (member_exists == 1) ? members : null,
                    // rwaImage: (member_exists == 2) ? members : null,
                    carnival_id: id
                });
                // setInputList((member_exists == 1) ? members : [{ name:"",image_url: "", position: ""}]);
                // setRwaMember((member_exists == 1) ? 'Yes' : 'No');
                // setAddMembers(member_exists);
            // }, 100);
            
        }
    }, [prefilledData])

  const handleMeetingData = () => {
    if (
        formData.start_date !== '' &&
        formData.end_date !== '' &&
        formData.start_time !== '' &&
        formData.end_time !== '' &&
        formData.subject !== ''
    ) {
        handleValue({ ...formData, members: inputList, infra_id: infraId });
    } else handleValue(null);
  };
  useEffect(() => {
    handleMeetingData();
  }, [formData, inputList]);

    function onStartChange(value) {
        const { hour, minute } = value;
        setData({ ...formData, start_time: `${hour}:${minute}` });
    }
    function onEndChange(value) {
        const { hour, minute } = value;
        setData({ ...formData, end_time: `${hour}:${minute}` });
    }

    // handle input change
    const handleInputChange = (e, index, type) => {
        const { name, value } = e.target;
        const list = [...inputList];
        list[index][type] = value;
        setInputList(list);
    };
    const saveImage = (val, index=null) => {
        if (index != null) {
            const list = [...inputList];
            list[index]["image_url"] = val;
            setInputList(list);
        } else {
            if (prefilledData?.carnival.member_exists == 2) {
                setData({ ...formData, rwaImage: prefilledData?.carnival.members });
            } else {
                setData({ ...formData, rwaImage: val });
            }
        }
    };

      
    // handle click event of the Remove button
    /*const handleRemoveClick = index => {
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
    };
    // handle click event of the Add button
    const handleAddClick = () => {
        var size = Object.keys(inputList).length;
        if (size >= 3) {
            toast.error('RWA members limit cannot exceed 3.');
        } else {
            setInputList([...inputList, { name:"",image_url: "", position: ""}]);
        }
    };*/
    const checkInfraId = (infra_id) => {
        (async () => {
              let res = await getLeadInfraId((infraIdToCheck !== undefined) ? infraIdToCheck : infra_id);
              if (res?.resultSets) {
              }
            })();
    };

  return (
    <FormSection title={localization.helpdeskDetails}>
        <div className="row">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={localization.projectId}
                    value={infraId !== 0 ? infraId : null}
                    handleChange={(value) => setInfraIdToCheck(value)}
                    disabled={formData?.isEdit}
                />
            </div>
            <div className="col-md-2 col-sm-5">
                <button className="btn btn-sm btn-primary" onClick={checkInfraId}>Check</button>
            </div>

        </div>
        
        {infraId !== 0 ? (
        <>
        <div className="row form-group">
            <div className="col-md-6 col-sm-12">
                <ConstantInput
                    label={localization.projectName}
                    value={projectName}
                    disabled
                />
            </div>
            {/*<div className="col-md-6 col-sm-12">
                <ConstantInput
                    value={formData.subject}
                    label={localization.societyName}
                    errorMsg={localization.enterSocietyName}
                    type="text"
                    maxLength={20}
                    required
                    handleChange={(value) => setData({ ...formData, subject: value })}
                    isStarRequired={true}
                    fullWidth
                />
            </div>*/}
        </div>
          <div className="row form-group">
            <div className="col-md-6 col-sm-12">
                <FormGroup
                    className={`date custom_date_picker active-date`}
                >
                    <DatePickerInput
                    value={formData?.start_date ? new Date(formData?.start_date) : null}
                    onChange={handleStartDate}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    required
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    minDate={new Date()}
                    // value={formData?.start_date}
                    />
                    <label>
                    {localization.startDate}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span>
                    </label>
                
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup>
                    <TimePicker
                    theme="classic"
                    timeFormat="HH:MM"
                    timeMode={24}
                    time={formData?.start_time}
                    onTimeChange={onStartChange}
                    />
                    <label>{localization.startTime}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span></label>
                    <label className="error date_error">{localization.isRequired}</label>
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup
                    className={`date custom_date_picker active-date`}
                >
                    <DatePickerInput
                    value={formData?.end_date ? new Date(formData?.end_date) : null}
                    onChange={handleEndDate}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    required
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    minDate={minDateIndex === null 
                        ? new Date()
                        : minDateIndex}
                    />
                    <label>
                    {localization.endDate}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span>
                    </label>
                
                </FormGroup>
            </div>
            <div className="col-md-6 col-sm-12">
                <FormGroup>
                    <TimePicker
                    theme="classic"
                    timeFormat="HH:MM"
                    timeMode={24}
                    time={formData?.end_time}
                    onTimeChange={onEndChange}
                    />
                    <label>{localization.endTime}{' '}
                    <span className="label-star" style={{ color: 'red' }}>
                        {' '}
                        *{' '}
                    </span></label>
                    <label className="error date_error">{localization.isRequired}</label>
                </FormGroup>
            </div>
        </div>

        <div className="row form-group">
            
        </div>

        </>
        ) : null}

    </FormSection>
  );
};

CarnivalForm.propTypes = {};

export default CarnivalForm;
